import { AppUrls } from '../../../../../common/dto/app-urls';
import { Route } from '@angular/router';
import { KnowledgeBaseRoute } from './knowledge-base/knowledge-base.routes';

export const HelpRoute: Route = {
  path: AppUrls.Dashboard._.Help.relativeUrl,
  children: [
    KnowledgeBaseRoute,
    {
      path: '**',
      redirectTo: KnowledgeBaseRoute.path,
    },
  ],
};
